import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../guards/auth.guard';
import { MarketplaceListingsComponent } from './marketplace-listings.component';
import { JobOverviewComponent } from './job-overview.component';
import { MarketplaceAcceptJobComponent } from './marketplace-accept-job.component';


const routes: Routes = [
 {
    path: '',
    component: MarketplaceListingsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: ':id',
    component: JobOverviewComponent,
    canActivate: [AuthGuard]
  },
  {
    path: ':id/accept',
    component: MarketplaceAcceptJobComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MarketplaceRoutingModule { }
